import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import { publisherApi } from '../api/api'
import { CreatePublisher, Publisher } from '../types/publisher'
// import {
//   CalendarPublisher,
//   CreatePublisher,
//   Publisher,
//   UpcomingPublishers,
// } from '../types/publisher'
// import { loadAllPublishers, modifyPublisher, removePublisher, savePublisher } from '../api/publisher'
// import { findCurrentTimePeriodPublishers } from '../utils/findCurrentTimePeriodPublishers'
// import { isWithinInterval } from 'date-fns'
// import { findPublishersByDate } from '../utils/findPublishersByDate'

// load all publishers
export const loadAllPublishers = createAsyncThunk(
  'publisher/loadAllPublishers',
  async (_, thunkApi) => {
    try {
      return await publisherApi.getPublishers()
    } catch (e) {
      return thunkApi.rejectWithValue('getPublishersError')
    }
  },
)

// load publisher
export const loadPublisher = createAsyncThunk(
  'publisher/loadPublisher',
  async (id: string, thunkApi) => {
    try {
      return await publisherApi.getPublisher(id)
    } catch (e) {
      return thunkApi.rejectWithValue('getPublishersError')
    }
  },
)

// add publisher
export const addPublisher = createAsyncThunk(
  'publisher/addPublisher',
  async (publisher: CreatePublisher, thunkApi) => {
    try {
      return await publisherApi.createPublisher(publisher)
    } catch (e) {
      return thunkApi.rejectWithValue('addPublisherError')
    }
  },
)

// // update publisher
// export const updatePublisher = createAsyncThunk(
//   'publisher/updatePublisher',
//   async (publisher: Publisher, thunkApi) => {
//     try {
//       return await modifyPublisher(publisher)
//     } catch (e) {
//       return thunkApi.rejectWithValue('updatePublisherError')
//     }
//   },
// )

// // delete objective
// export const deletePublisher = createAsyncThunk(
//   'publisher/deletePublisher',
//   async (id: string, thunkApi) => {
//     try {
//       return await removePublisher(id)
//     } catch (e) {
//       return thunkApi.rejectWithValue('deletePublisherError')
//     }
//   },
// )

interface PublisherSliceState {
  publishers: Publisher[]
  publisher?: Publisher
  loading: boolean
  loadedAllPublisher: boolean
  error?: SerializedError
}

const initialState: PublisherSliceState = {
  publishers: [],
  publisher: undefined,
  loading: false,
  loadedAllPublisher: false,
  error: undefined,
}

const publisherSlice = createSlice({
  name: 'publisher',
  initialState,
  reducers: {
    setPublisher: (
      state: PublisherSliceState,
      action: PayloadAction<Publisher | undefined>,
    ) => {
      state.publisher = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    // get all publishers
    // @ts-ignore
    builder.addCase(
      loadAllPublishers.fulfilled,
      (state: PublisherSliceState, action: PayloadAction<Publisher[]>) => {
        state.publishers = action.payload?.sort((a, b) =>
          a.name.eng.localeCompare(b.name.eng),
        )
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(
      loadAllPublishers.pending,
      (state: PublisherSliceState, action) => {
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(loadAllPublishers.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })

    // load publisher
    // @ts-ignore
    builder.addCase(
      loadPublisher.fulfilled,
      (state: PublisherSliceState, action: PayloadAction<Publisher>) => {
        state.publisher = action.payload
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(
      loadPublisher.pending,
      (state: PublisherSliceState, action) => {
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(loadPublisher.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })

    // Add publisher
    // @ts-ignore
    builder.addCase(
      addPublisher.fulfilled,
      (state: PublisherSliceState, action: PayloadAction<Publisher>) => {
        state.publishers = [...state.publishers, action.payload].sort((a, b) =>
          a.name.eng.localeCompare(b.name.eng),
        )
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(
      addPublisher.pending,
      (state: PublisherSliceState, action) => {
        state.loadedAllPublisher = true
        state.error = undefined
      },
    )

    builder.addCase(addPublisher.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })
  },
})

export const { setPublisher } = publisherSlice.actions
export default publisherSlice
